import axiosClient from "utils/api";
const URI = "/admin/country";

export const getCountry = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get Country:", error);
    throw error;
  }
};

export const deleteCountry = async (payload) => {
  const URL = `${URI}/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Delete Country:", error);
    throw error;
  }
};

export const updateCountry = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Update Country:", error);
    throw error;
  }
};

export const updateDefaultCountry = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/default/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Update Country:", error);
    throw error;
  }
};

export const addCountry = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Add Country:", error);
    throw error;
  }
};
